import { createBlock } from 'factories/block';
import getStore from 'services/getStore';

const { getState } = getStore();

export const createEditableBtn = ({ ...props }) => {
  const { theme } = getState();

  const {
    buttonBackgroundColor,
    buttonTextColor,
    buttonShape = 'pill',
    buttonShadow = true,
  } = theme;

  // const buttonTextColor = theme.buttonTextColor || props.buttonTextColor;
  //

  return createBlock('EditableButton', [], {
    props: {
      type: props.type || 'editableButton',
      label: props.label || 'Edit',
      background: buttonBackgroundColor,
      color: buttonTextColor,
      buttonShape,
      buttonShadow,
      borderWidth: 1,
      // buttonOutline: props.buttonOutline,
      // localButtonOutline: props.localButtonOutline || false,
      shape: buttonShape, // 'pill',
      font: '',
      ...props,
    },
    meta: { subType: 'editableButton' },
  });
};
